import { defineMessages } from 'react-intl'

export default defineMessages({
  creditCardInformation: {
    id: 'Redeem.pay.creditCardInformation',
    defaultMessage: 'Card details',
  },
  cardNumber: {
    id: 'Redeem.pay.cardNumber',
    defaultMessage: 'Card number',
  },
  nameOnCard: {
    id: 'Redeem.pay.nameOnCard',
    defaultMessage: 'Name on card',
  },
  expiration: {
    id: 'Redeem.pay.expiration',
    defaultMessage: 'Exp. (MM/YY)',
  },
  CVCCode: {
    id: 'Redeem.pay.CVCCode',
    defaultMessage: 'CVC Code',
  },
  pay: {
    id: 'Redeem.pay.pay',
    defaultMessage: 'Pay now',
  },
  'pay.btn': {
    id: 'pay.btn',
    defaultMessage: 'Start your health journey',
  },
  'pay.free_trial_btn': {
    id: 'pay.free_trial_btn',
    defaultMessage: 'Start free trial',
  },
  'pay.free_trial_info': {
    id: 'pay.free_trial_info',
    defaultMessage:
      'We will not charge anything to your card until your trial is over. Your subscription will then renew automatically if not canceled.',
  },
  amountDue: {
    id: 'Redeem.pay.amountDue',
    defaultMessage: 'Amount due',
  },
  amountDueInDays: {
    id: 'Redeem.pay.amountDueInDays',
    defaultMessage: 'Amount due in {days} days',
  },
  paymentAccepted: {
    id: 'Redeem.pay.paymentAccepted',
    defaultMessage: 'Payment accepted!',
  },
  processingPayment: {
    id: 'Redeem.pay.processingPayment',
    defaultMessage: 'Processing payment',
  },
  cardRefused: {
    id: 'Redeem.pay.cardRefused',
    defaultMessage:
      'The card was refused. Please make sure you got everything right.',
  },
  invalidCardNumber: {
    id: 'Redeem.pay.invalidCardNumber',
    defaultMessage:
      'Please check that the card number has been entered correctly',
  },
  didntGoAsPlanned: {
    id: 'Redeem.pay.didntGoAsPlanned',
    defaultMessage: 'Something didn’t go as planned',
  },
  alreadyPremium: {
    id: 'general.already_premium',
    defaultMessage: 'This account already has Lifesum Premium 😀',
  },
  'SignUp.SubWillRenew': {
    id: 'SignUp.SubWillRenew',
    defaultMessage: 'Subscription will renew automatically if not cancelled.',
  },
  'pay.boring': {
    id: 'pay.boring',
    defaultMessage: 'The boring stuff before the good stuff.',
  },
  pay_btn_gift: {
    id: 'pay_btn_gift',
    defaultMessage: 'Purchase gift',
  },
  your_email: {
    id: 'your_email',
    defaultMessage: 'Your e-mail',
  },
  cvcCodeDeclined: {
    id: 'Redeem.pay.cvcCodeDeclined',
    defaultMessage: 'Please check that you have entered the correct CVC',
  },
  contactCustomerSupport: {
    id: 'Redeem.pay.contactCustomerSupport',
    defaultMessage:
      'If you need any help, please contact support at <a>https://lifesum.com/contact</a>',
  },
  subscriptionAppliesInAppNotice: {
    id: 'Redeem.pay.subscriptionAppliesInAppNotice',
    defaultMessage:
      'Premium subscriptions purchased here on the website can be accessed on the app by logging in with the same account and email address used for purchase.',
  },
  manageSubscription: {
    id: 'UserAccount_Navigation_ManageSubscriptionLink',
    defaultMessage: 'Manage Subscription',
  },
  pay_paypal_text: {
    id: 'pay_paypal_text',
    defaultMessage:
      'Use the button below to log in and pay with your PayPal account.',
  },
  pay_continue_to_paypal: {
    id: 'pay_continue_to_paypal',
    defaultMessage: 'Continue to PayPal',
  },
  'upgrade.connected.info': {
    id: 'upgrade.connected.info',
    defaultMessage:
      "You're upgrading the account connected to {email} to Premium. Not you?",
  },
  'SignUp.logInHere': {
    id: 'SignUp.logInHere',
    defaultMessage: 'Log in here',
  },
  expiredMessage: {
    id: 'Redeem.start.expiredMessage',
    defaultMessage: 'We’re sorry but the code has expired.',
  },
  invalidMessage: {
    id: 'Signup.invalidCode',
    defaultMessage: 'Sorry, the code is invalid.',
  },
})
